import classNames from 'classnames';
import styles from './NumList.module.scss';

const NumList = ({ className, children }) => {
  return (
    <ol
      className={classNames([styles['num-list'], className])}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      {children}
    </ol>
  );
};

export default NumList;
